import api from "./api";

export interface ScoreItem {
  fecha: string;
  puntaje: number;
  ts: number;
}

export interface ScoreHistory {
  puntajes: ScoreItem[];
}

export interface RecapPayload {
  count: number;
  loginCount: number;
  scoreHistory: ScoreHistory;
}

export interface ReportsRecapResponse {
  success: boolean;
  errors: any[];
  payload: RecapPayload;
}

export const url = "reports/recap";

const reportsRecapGet = async (): Promise<ReportsRecapResponse> => {
  return await api.get(url, true);
};

export default reportsRecapGet;
